import React, { useState, useEffect } from 'react';

const QuickNavDots = () => {
  const [activeSection, setActiveSection] = useState(0);

  const sections = [
    { id: 'platform', label: 'Платформа' },
    { id: 'features', label: 'Возможности' },
    { id: 'clients', label: 'Клиенты' },
    { id: 'pricing', label: 'Цены' },
    { id: 'demo', label: 'Демо' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      const sectionElements = sections?.map(section => ({
        id: section?.id,
        element: document.getElementById(section?.id),
      }));

      const scrollPosition = window.scrollY + 200;

      for (let i = sectionElements?.length - 1; i >= 0; i--) {
        const section = sectionElements?.[i];
        if (section?.element && section?.element?.offsetTop <= scrollPosition) {
          setActiveSection(i);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element?.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth',
      });
    }
  };

  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-[10] hidden xl:flex flex-col space-y-4">
      {sections?.map((section, index) => (
        <div
          key={section?.id}
          className="relative group cursor-pointer"
          onClick={() => scrollToSection(section?.id)}
        >
          <div
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              activeSection === index
                ? 'bg-primary scale-150 neon-glow-primary' :'bg-muted-foreground/50 hover:bg-muted-foreground hover:scale-125'
            }`}
          />
          <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
            <div className="glassmorphism px-3 py-1.5 rounded-lg whitespace-nowrap">
              <span className="text-xs font-medium text-foreground">{section?.label}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default QuickNavDots;